<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <br />
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Revision de Materiales</v-toolbar-title
              >
            </v-toolbar>
            <v-layout justify-center>
              <v-flex xs12 md3>
                <v-select
                  v-model="regionValue"
                  :items="regionSelect"
                  label="Region"
                  item-text="name"
                  item-value="code"
                ></v-select>
              </v-flex>
              <v-flex xs12 md3>
                <v-select
                  v-model="nivelValue"
                  :items="nivelSelect"
                  label="Nivel"
                  item-text="name"
                  item-value="code"
                ></v-select>
              </v-flex>
              <v-btn
                fab
                dark
                color="teal"
                title="Filtrar detalle"
                @click="filterGra()"
              >
                <v-icon dark>filter_list</v-icon>
              </v-btn>
              <!-- BOTON NO INCLUIDO EN DISEÑO DEBERIA ESTAR -->
              <v-btn
                fab
                dark
                color="red darken-4"
                title="Limpiar filtros"
                @click="clear()"
              >
                <v-icon dark>clear_all</v-icon>
              </v-btn>
            </v-layout>
            <v-layout>
              <v-flex>
                <div>
                  <v-layout row wrap>
                    <v-flex lg12 sm12 xs12>
                      <div v-if="loading">
                        <loading></loading>
                      </div>
                      <div>
                        <grafica-avance
                          v-for="(graf, indexChart) in pruebas"
                          :key="indexChart"
                          :res="res[indexChart]"
                          :titulo="titleGrafica[indexChart]"
                          :titleIn="titleTest[indexChart]"
                        ></grafica-avance>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GraficaAvance from "@/modules/aplicacion/views/revision/GraficaAvance.vue";
import API from "@/api";
import Loading from "@/views/ui/Loading.vue";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import { mapState } from "vuex";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import { misMixins } from "@/mixins/myMixing.js";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "porcentaje-avance",

  components: {
    GraficaAvance,
    VWidget,
    EChart,
    Loading,
    CircleStatistic,
    LoadingDescarga,
  },

  props: {},

  data() {
    return {
      loading: false,
      color: Material,
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      menu1: false,
      filter: false,
      usuarioLogged: "",
      gridDocumento: 20,
      idEstado: "",
      tipeCenter: "",
      idContrato: "",
      tabSelected: "",
      regionValue: null,
      regionSelect: [],
      nivelValue: null,
      nivelSelect: [],
      indexChart: 0,
      res: [],
      titleGrafica: [],
      titleTest: [],
      pruebas: [],
    };
  },

  mounted() {},
  created() {
    this.tabSelected = this.$store.getters.subTabSelectedStored;
    this.usuarioLogged = this.$store.getters.userLogged;
    this.tipeCenter = this.$store.getters.subTabSelectedStored;
    this.idContrato = this.$store.getters.contratoStored;

    this.loadData();
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },

    selected(tab) {
      this.tabSelect = tab;
    },

    filterGra() {
      this.loadDataFiltro();
    },
    clear() {
      this.nivelValue = "";
      this.regionValue = "";
      this.loadData();
    },

    async loadDataFiltro() {
      this.loading = true;
      this.pruebas = [];
      this.pruebas = await this.loadFilter();

      if (this.pruebas.length > 0) {
        this.showAlert = false;
        this.indexChart = 0;

        this.pruebas.forEach((m) => {
          let data = [];

          this.titleGrafica[this.indexChart] =
            "Region: " + m.sRegion + " - Nivel: " + m.nivel;
          data.push({
            nivel: "%",
            Revisados: m.porcentajeCursosRevisados,
            "Revisados Sin Error": m.porcentajeCursosRevisadosNok,
            "Revisados Con error": m.porcentajeCursosRevisadosOk,
          });

          this.res[this.indexChart] = data;
          this.indexChart += 1;
        });
        this.loadNivelSelect();
        this.loadRegionSelect();
      } else {
        this.showAlert = true;
      }
      this.loading = false;
    },

    async loadData() {
      this.loading = true;
      this.pruebas = [];
      this.pruebas = await this.loadFilter();

      if (this.pruebas.length > 0) {
        this.showAlert = false;
        this.indexChart = 0;

        this.pruebas.forEach((m) => {
          let data = [];

          this.titleGrafica[this.indexChart] =
            "Region: " + m.sRegion + " - Nivel: " + m.nivel;
          data.push({
            nivel: "%",
            Revisados: m.porcentajeCursosRevisados,
            "Revisados Sin Error": m.porcentajeCursosRevisadosNok,
            "Revisados Con error": m.porcentajeCursosRevisadosOk,
          });

          this.res[this.indexChart] = data;
          this.indexChart += 1;
        });
        this.loadNivelSelect();
        this.loadRegionSelect();
      } else {
        this.showAlert = true;
      }
      this.loading = false;
    },
    loadNivelSelect() {
      let reg = [];
      this.pruebas.forEach(function (d) {
        if (d.nivel != null) {
          let index = reg.findIndex((x) => x.code == d.idregion);
          if (index === -1) {
            if (d.nivel != null && d.nivel != "") {
              reg.push({ name: d.nivel, code: d.nivel });
            }
          }
        }
      });
      this.nivelSelect = reg;
    },
    loadRegionSelect() {
      let reg = [];
      this.pruebas.forEach(function (d) {
        if (d.sRegion != null) {
          let index = reg.findIndex((x) => x.code == d.idregion);
          if (index === -1) {
            if (d.idregion != null && d.idregion != "") {
              reg.push({ name: d.sRegion, code: d.idregion });
            }
          }
        }
      });
      this.regionSelect = reg;
    },

    async loadFilter() {
      let idContrato = this.$store.getters.contratoStored;
      this.nivelFiltro = this.nivelValue;
      this.regionFiltro = this.regionValue;

      if (this.nivelFiltro > 0) {
        this.body = {
          idContrato: idContrato,
          idregion:
            this.regionValue && this.regionValue != null
              ? this.regionValue
              : null,
          nivel: this.nivelFiltro,
        };
      } else if (this.regionFiltro > 0) {
        this.body = {
          idContrato: idContrato,
          idregion: this.regionFiltro,
          nivel:
            this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        };
      } else {
        this.body = {
          idContrato: idContrato,
          idregion:
            this.regionValue && this.regionValue != null
              ? this.regionValue
              : null,
          nivel:
            this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        };
      }

      return await axios
        .post("/revisionMaterial/evolucion/all", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    downloadCenter() {
      this.dialogLoading = true;
      let that = this;
      let filename = "Centros_" + this.tipeCenter + ".xls";
      axios({
        url: "/centro/download/" + this.tipeCenter + "/" + this.contratoId,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    downloadComplete() {
      this.dialogLoading = true;
      let filename = "Descarga_Completa_Revision.xlsx";

      axios({
        url: "/revisionMaterial/downloadRevisiones/" + this.idContrato,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
  },
};
</script>
